/**
 * Normalize the many shapes a stored instant can take into epoch millis —
 * the ONE copy both the client and the Cloud Functions run.
 *
 * Accepted shapes: a number (already millis), a `Date`, a Firestore
 * `Timestamp` from either SDK (`toMillis()`), a plain `{ seconds }` object
 * (a Timestamp that went through JSON), and a plain `{ _seconds }` object —
 * a serialized Admin `Timestamp`, which only ever reached the server copy
 * before the two were merged; the client accepts it now too, harmlessly.
 * Anything else (null, undefined, a string, an empty object) is 0.
 */
export function toMillis(value) {
  if (value == null) return 0;
  if (typeof value === "number") return value;
  if (typeof value.toMillis === "function") return value.toMillis();
  if (value instanceof Date) return value.getTime();
  if (typeof value.seconds === "number") return value.seconds * 1000;
  if (typeof value._seconds === "number") return value._seconds * 1000;
  return 0;
}
